/* eslint-disable jsx-a11y/alt-text */
import Slider from "react-slick";
import { useState } from "react";
import cal from "../../../assets/images/newsec2.png";
import second from "../../../assets/images/cal2.png";
import third from "../../../assets/images/cal3.png";
import time from "../../../assets/images/cal4.png";
import end from "../../../assets/images/cal5.png";
import line from "../../../assets/images/line.png";
import styles from "../second/second.module.scss";
import { Col, Row } from "react-bootstrap";
const Second = () => {
  const [activeTab, setActiveTab] = useState(0);
  // slider
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    afterChange: (index: any) => {
      // Update the active tab when the slider changes
      setActiveTab(index);
    },
    style: {
      marginLeft: "20px", // Add left margin
      marginRight: "20px", // Add right margin
    },
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 576, // Define a breakpoint at 1024px or any desired width
        settings: {
          slidesToShow: 1, // Adjust the number of slides to show for this breakpoint
        },
      },
      {
        breakpoint: 767, // Define a breakpoint at 1024px or any desired width
        settings: {
          slidesToShow: 1, // Adjust the number of slides to show for this breakpoint
        },
      },
      {
        breakpoint: 992, // Define a breakpoint at 1024px or any desired width
        settings: {
          slidesToShow: 2, // Adjust the number of slides to show for this breakpoint
        },
      },
      // {
      //   breakpoint: 768, // Define a breakpoint at 768px or any desired width
      //   settings: {
      //     slidesToShow: 1, // Adjust the number of slides to show for this breakpoint
      //   },
      // },
      // Add more breakpoints and settings as needed
    ],
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />, // Use the custom component here
    // prevArrow: <CustomPrevArrow />,
  };
  return (
    <div className="container">
      <div className={styles.mainsecond}>
        <div className={styles.head}>
          <p>
            <img className={styles.first} src={line} />
            Why Choose
            <img className={styles.sec} src={line} />
          </p>
          <span>CID The Inspection Company</span>
        </div>
        <Row className={`${"mt-5"} ${styles.main_second}`}>
          <Col lg={5}>
            <div className={styles.one}>
              <div className={styles.card_bx}>
                <p>
                  <img width="60px" height="60px" src={cal} />
                </p>
                <p>Quick & Easy Scheduling</p>
                <span>
                  Schedule an inspection based on your availability via phone or
                  a call.
                </span>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className={styles.tab}>
              <Row>
                <Col md={6} lg={6}>
                  <div className={styles.xs_card}>
                    <div className={styles.card_bx}>
                      <p>
                        <img width="60px" height="60px" src={second} />
                      </p>
                      <p>Timely Project Completion</p>
                      <span>
                        Avoid inspection-related delays, ensuring your projects
                        stay on schedule and within budget.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={6}>
                  <div className={`${styles.xs_card} ${styles.back_img}`}>
                    <div className={styles.card_bx}>
                      <p>
                        <img width="60px" height="60px" src={third} />
                      </p>
                      <p>Hassle-Free Appointment</p>
                      <span>
                        Enjoy seamless appointment management with real-time
                        updates through our user-friendly app and on-call
                        customer support.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={6}>
                  <div className={`${styles.xs_card} ${styles.back_img2}`}>
                    <div className={styles.card_bx}>
                      <p>
                        <img width="60px" height="60px" src={time} />
                      </p>
                      <p>24*7 Access To Records</p>
                      <span>
                        Keep all inspection records in one place and keep
                        documentation complete.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={6}>
                  <div className={`${styles.xs_card} ${styles.back_img3}`}>
                    <div className={styles.card_bx}>
                      <p>
                        <img width="60px" height="60px" src={end} />
                      </p>
                      <p>End-to-End Management</p>
                      <span>
                        Experience complete process management, from timely
                        inspections to efficient reporting to the Township to
                        accessing licensed inspectors.
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Second;
